import { Link as RouterLink } from 'react-router-dom';

import { Box, Link, useTheme } from '@mui/material';

import { AppTypography } from '~components/ui/typography/app-typography';

import { useBreadcrumbs, BreadcrumbRoute } from '~hooks/use-bread-crumbs';

interface Props {
  routes: BreadcrumbRoute[];
}

export const Breadcrumbs = ({ routes }: Props) => {
  const theme = useTheme();
  const crumbs = useBreadcrumbs(routes);

  if (crumbs.length === 0) return null;

  return (
    <Box
      sx={{
        padding: '8px 24px',
        borderRadius: 2,
        backgroundColor: 'fog.90',
        width: '100%',
        boxSizing: 'border-box',
        display: 'flex',
        alignItems: 'center',
        flexWrap: 'wrap',
      }}
    >
      {/*<MUIBreadcrumbs*/}
      {/*  aria-label="breadcrumb"*/}
      {/*  separator={<AppIcon component={ArrowRight} />}*/}
      {/*>*/}
      {crumbs.map((crumb, index) => {
        const isLast = index === crumbs.length - 1;

        return isLast ? (
          <AppTypography key={crumb.href} size="body-md" color="fog.25">
            {crumb.label}
          </AppTypography>
        ) : (
          <>
            <Link
              key={crumb.href}
              component={RouterLink}
              to={crumb.href}
              underline="hover"
              color="primary"
              sx={{
                ...theme.typography['body-md'],
              }}
            >
              {crumb.label}
            </Link>
            <AppTypography
              key={`${crumb.href}/`}
              size="body-lg"
              color="fog.25"
              mx={1}
            >
              /
            </AppTypography>
          </>
        );
      })}
      {/*</MUIBreadcrumbs>*/}
    </Box>
  );
};
